import { render, staticRenderFns } from "./fwUpdateIndex.vue?vue&type=template&id=00505c94&scoped=true"
import script from "./fwUpdateIndex.vue?vue&type=script&lang=js"
export * from "./fwUpdateIndex.vue?vue&type=script&lang=js"
import style0 from "./fwUpdateIndex.vue?vue&type=style&index=0&id=00505c94&prod&lang=scss&scoped=true"
import style1 from "./fwUpdateIndex.vue?vue&type=style&index=1&id=00505c94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00505c94",
  null
  
)

export default component.exports